var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-DP"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DP",
    clipPath: "url(#clip-DP)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2376",
    "data-name": "Group 2376",
    transform: "translate(9 8)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_840",
    "data-name": "Ellipse 840",
    cx: 241.5,
    cy: 241.5,
    r: 241.5,
    fill: "#fd8469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4110",
    "data-name": "Path 4110",
    d: "M255.084,362.8c-.381,0-.761.381-1.142.381s-.761-.381-1.142-.381Z",
    transform: "translate(-12.249 -17.579)",
    fill: "#84dbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4111",
    "data-name": "Path 4111",
    d: "M432.09,410.259a241.55,241.55,0,0,1-375.29,0c31.591-42.249,79.93-63.183,119.514-73.459-3.045,25.121,9.9,58.615,10.277,57.854,13.322-30.449,57.854-33.114,57.854-33.114s44.532,2.664,57.473,33.114c.381.761,13.7-32.733,10.277-57.854C352.16,347.077,400.879,368.011,432.09,410.259Z",
    transform: "translate(-2.752 -16.319)",
    fill: "#84dbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4112",
    "data-name": "Path 4112",
    d: "M305.657,311.244v.381c0,3.806-1.9,28.166-53.287,47.577h-2.284C198.7,339.791,196.8,315.431,196.8,311.625v-.381c0-4.948,1.142-9.9,2.284-14.844,14.844,18.65,32.733,31.211,52.145,31.211s37.3-12.56,52.145-31.211C304.515,301.348,305.657,306.3,305.657,311.244Z",
    transform: "translate(-9.536 -14.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4113",
    "data-name": "Path 4113",
    d: "M304.941,312s2.664,27.4-54.428,48.719c0,0,44.532,2.664,57.473,33.114C308.747,394.594,334.249,328.367,304.941,312Zm-108.857,0c-29.308,16.367-3.806,82.594-3.045,81.452,13.322-30.449,57.473-33.114,57.473-33.114C193.42,339.4,196.084,312,196.084,312Z",
    transform: "translate(-8.82 -15.117)",
    fill: "#54c0eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4114",
    "data-name": "Path 4114",
    d: "M328.806,205.824c-3.426,23.6-13.7,45.674-30.83,62.421A73.665,73.665,0,0,1,287.7,277l-6.09-19.412H216.143L210.053,277c-12.18-9.135-37.681-34.636-38.062-58.615C161.334,81.743,266,110.67,266,110.67,336.418,105.722,334.135,167.762,328.806,205.824Zm14.083,24.74c-5.329,8.754-12.56,14.844-19.412,17.128a161.513,161.513,0,0,0,6.851-19.031v-.381l4.567-17.128h-.381c1.522-5.709,3.045-11.419,4.187-17.128a10.819,10.819,0,0,1,4.567,1.522c8.374,5.329,7.993,20.934-.381,35.017ZM174.275,247.692c-6.851-2.284-14.083-8.374-19.412-17.128-8.754-14.083-8.754-29.688-.381-34.636.761-.381,1.142-.761,1.9-.761a259.183,259.183,0,0,0,11.038,33.875,184.276,184.276,0,0,0,6.851,18.65Z",
    transform: "translate(-7.183 -5.238)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4115",
    "data-name": "Path 4115",
    d: "M290.177,69.132C293.222,34.115,237.652,36.4,237.652,36.4c-84.117,12.18-93.252,90.587-93.252,90.587l11.419-13.7c-17.889,39.2,9.135,106.573,11.419,111.9C181.32,272,212.531,315.011,248.69,315.011s67.369-43.01,81.452-89.826V224.8c1.522-5.709,3.045-11.419,4.187-17.128h-.381c7.612-30.449,15.986-61.28,15.986-61.28,21.7-109.238-59.757-77.266-59.757-77.266Zm38.443,133.217c-3.426,23.6-13.7,45.674-30.83,62.421a104.867,104.867,0,0,1-10.277,8.754l-6.09-19.031H215.956l-6.09,19.412c-12.18-9.135-22.456-21.7-30.83-36.159a80.81,80.81,0,0,1-7.232-22.456c-10.657-136.642,94.013-107.715,94.013-107.715,70.414-5.329,68.131,56.712,62.8,94.774Z",
    transform: "translate(-6.997 -1.762)",
    fill: "#324a5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4116",
    "data-name": "Path 4116",
    d: "M290.177,69.132C293.222,34.115,237.652,36.4,237.652,36.4c-84.117,12.18-93.252,90.587-93.252,90.587l11.419-13.7c-17.889,39.2,9.135,106.573,11.419,111.9C181.32,272,212.531,315.011,248.69,315.011s67.369-43.01,81.452-89.826V224.8c1.522-5.709,3.045-11.419,4.187-17.128h-.381c7.612-30.449,15.986-61.28,15.986-61.28,21.7-109.238-59.757-77.266-59.757-77.266Zm38.443,133.217c-3.426,23.6-13.7,45.674-30.83,62.421a104.867,104.867,0,0,1-10.277,8.754l-6.09-19.031H215.956l-6.09,19.412c-12.18-9.135-22.456-21.7-30.83-36.159a80.81,80.81,0,0,1-7.232-22.456c-10.657-136.642,94.013-107.715,94.013-107.715,70.414-5.329,68.131,56.712,62.8,94.774Z",
    transform: "translate(-6.997 -1.762)",
    fill: "#324a5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4117",
    "data-name": "Path 4117",
    d: "M290.177,69.132C293.222,34.115,237.652,36.4,237.652,36.4c-84.117,12.18-93.252,90.587-93.252,90.587l11.419-13.7c-17.889,39.2,9.135,106.573,11.419,111.9C181.32,272,212.531,315.011,248.69,315.011s67.369-43.01,81.452-89.826V224.8c1.522-5.709,3.045-11.419,4.187-17.128h-.381c7.612-30.449,15.986-61.28,15.986-61.28,21.7-109.238-59.757-77.266-59.757-77.266Zm38.443,133.217c-3.426,23.6-13.7,45.674-30.83,62.421a104.867,104.867,0,0,1-10.277,8.754l-6.09-19.031H215.956l-6.09,19.412c-12.18-9.135-37.681-34.636-38.062-58.615-10.657-136.642,94.013-107.715,94.013-107.715,70.414-5.329,68.131,56.712,62.8,94.774Z",
    transform: "translate(-6.997 -1.762)",
    fill: "#324a5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4118",
    "data-name": "Path 4118",
    d: "M226,279.2a35.939,35.939,0,0,0,26.643,12.18,34.635,34.635,0,0,0,26.643-12.18Z",
    transform: "translate(-10.95 -13.528)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDp);
export default __webpack_public_path__ + "static/media/DP.e868556a.svg";
export { ForwardRef as ReactComponent };